<script>
import formatDate from '@utils/format-date'
import  { formatOrder } from "@utils/format-order";
import formatPrice from "@utils/format-price";

export default {
  props: {
    addOrderList: {
      type: Array,
      default: () => {
        return [
          {
            "id": "963f4023-a0e4-420e-9cb5-902e01abefd5",
            "orderNo": "JTAIL2107230001DQU0EADD3F",
            "parentId": "95e92570-fd84-4da9-9534-f641508bc0c6",
            "status": 0,
            "fullName": "測試員",
            "total": 200,
            "payTotal": 0,
            "unpaidTotal": 0,
            "paymentMethod": "Cash",
            "paymentExpiredDate": null,
            "createdDate": "2021-08-06 13:49:14",
            "paidDate": "2021-08-17 14:20:21",
            "cancelDate": "2021-08-06 13:49:55",
            "addItems": [
              {
                "title": "精油按摩",
                "status": 0,
                "basePrice": 200,
                "price": 200,
                "total": 200
              },
            ],
            "store": {
              "title": "台北店"
            }
          }
        ]
      }
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    formatDate,
    formatOrder,
    formatPrice,
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.addOrderToggle">
    <div v-if="isShow">
      <div class="addOrderToggle__title">子訂單</div>
      <ul :class="$style.addOrderList">
        <li
          v-for="(addOrderItem, index) in addOrderList"
          :key="`addOrderList-${index}`"
          class="addOrderList__item"
        >
          <ul :class="$style.addItemList">
            <li class="addItemList__item">#{{ addOrderItem.containerDisplayId }}</li>
            <li class="addItemList__item">
              <span>訂單狀態：</span>
              <span :class="`text-${formatOrder(addOrderItem.status).color}`">
                {{ formatOrder(addOrderItem.status).title }}
              </span>
            </li>
            <li class="addItemList__item">總計: {{ formatPrice(addOrderItem.priceTotal) }}</li>
            <li class="addItemList__item">訂單成立日期：{{ formatDate(addOrderItem.createdDate, 'yyyy/MM/dd') }}</li>
          </ul>
        </li>
      </ul>
    </div>
    <BaseButton
      class="isStylePrimary isOutline3 isSmall isFull"
      :class="{ 'isRadius': !$globalIsJtails }"
      @click="isShow = !isShow"
    >
      {{
        isShow
          ? '- 隱藏'
          : '+ 顯示 '
      }}子訂單
    </BaseButton>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.addOrderToggle {
  margin-bottom: 0.5rem;

  :global {
    .addOrderToggle {
      &__title {
        padding: 0.5rem 0;
        margin-bottom: 1rem;
        font-size: 0.75rem;
        text-align: center;
        background-color: rgba($color-secondary, 0.1);
      }
    }
  }
}

.addOrderList {
  @include list-unstyled;

  margin-bottom: 1rem;

  :global {
    .addOrderList {
      &__item {
        padding: 1rem 1.5rem;

        &:not(:last-child) {
          border-bottom: $color-gray-4 1px solid;
        }
      }
    }
  }
}

.addItemList {
  @include list-unstyled;

  margin-bottom: 0;
  font-size: 0.75rem;


  :global {
    .addItemList {
      &__item {
        line-height: 1.75;
      }
    }
  }
}
</style>
